import { Configuration } from '@/services'

const { SHOP_ORIGIN } = Configuration

export const handlePageNotFound = (res, query) => {
  const params = new URLSearchParams(query)
  const Location = `${SHOP_ORIGIN}/PageNotFound?${params}`
  if (process.browser && typeof window !== 'undefined' && window.location.href) {
    window.location.href = Location
  } else if (res && typeof res.writeHead === 'function') {
    res.writeHead(302, { Location })
    res.end()
  }
  return { statusCode: 302 } as any
}
